import { createAlert } from "actions/alerts";
import { closeModal } from "actions/modal";
import { CallApiAction } from "actions/types";
import keyConverter from "services/key-converter";
import { ModalBillingPaymentRecord } from "./services";

function getPayload(
  cardDetails: ModalBillingPaymentRecord,
  stripeToken: unknown
): Record<string, unknown> {
  const {
    address,
    cardholderName,
    city,
    country,
    postalCode
  } = cardDetails.toJS();

  return keyConverter(
    {
      address,
      cardholderName,
      city,
      country,
      postalCode,
      stripeToken
    },
    "underscore"
  );
}

export function postCreditCard(
  cardDetails: ModalBillingPaymentRecord,
  stripeToken: unknown
): CallApiAction {
  const payload = getPayload(cardDetails, stripeToken);

  return {
    CALL_API: {
      method: "post",
      endpoint: "/billings/card/",
      payload,
      types: [
        "POST_CREDIT_REQUEST",
        "POST_CREDIT_SUCCESS",
        "POST_CREDIT_FAILURE"
      ],
      args: {
        card: payload
      },
      dispatchCallbacks: [
        {
          request: createAlert,
          fireOnStatus: "success",
          args: {
            message: "Credit card successfully added.",
            alertType: "success"
          }
        },
        {
          request: createAlert,
          fireOnStatus: "error"
        },
        {
          request: closeModal,
          fireOnStatus: "success"
        }
      ]
    }
  };
}

export function patchCreditCard(
  cardDetails: ModalBillingPaymentRecord,
  stripeToken: unknown
): CallApiAction {
  const payload = getPayload(cardDetails, stripeToken);

  return {
    CALL_API: {
      method: "patch",
      endpoint: "/billings/card/",
      payload,
      types: [
        "UPDATE_CREDIT_REQUEST",
        "UPDATE_CREDIT_SUCCESS",
        "UPDATE_CREDIT_FAILURE"
      ],
      args: {
        card: payload
      },
      dispatchCallbacks: [
        {
          request: createAlert,
          fireOnStatus: "success",
          args: {
            message: "Credit card successfully updated.",
            alertType: "success"
          }
        },
        {
          request: createAlert,
          fireOnStatus: "error"
        },
        {
          request: closeModal,
          fireOnStatus: "success"
        }
      ]
    }
  };
}
